import { BRAND_COLORS } from '@/lib/brandColors'
import { CoursePagePremiumLoader } from '@/components/course/CoursePagePremiumLoader'
import { useAuth } from '@/lib/AuthContext'
import { isFreshSignup } from '@/lib/freshSignup'
import { logger } from '@/lib/logger'
import { redirectToWordPressLogin } from '@/lib/wordpress-redirect'
import { Redirect, Stack, usePathname } from 'expo-router'
import React, { useEffect } from 'react'
import { Platform, View } from 'react-native'

export default function AuthLayout() {
  const { user, loading } = useAuth()
  const pathname = usePathname()

  const isLoginPage = pathname.startsWith('/auth/login')
  const isSignupPage = pathname.startsWith('/auth/signup')
  const isAllowedPage = isLoginPage || isSignupPage

  __DEV__ && logger.debug('User Exists:', !!user)

  useEffect(() => {
    if (!user && !loading && !isAllowedPage && Platform.OS === 'web') {
      redirectToWordPressLogin()
    }
  }, [user, loading, isAllowedPage])

  if (loading) {
    __DEV__ && logger.debug('AuthLayout: Duke pritur (loading)...')
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <CoursePagePremiumLoader variant="auth" />
      </View>
    )
  }

  if (user) {
    // A brand-new account (just created on the signup screen) lands on the
    // plans screen first — install → sign up → plans → subscribe or skip —
    // matching the web's straight-to-/join funnel. Everyone else: dashboard.
    if (Platform.OS !== 'web' && isFreshSignup()) {
      return <Redirect href="/upgrade" />
    }
    return <Redirect href="/courses" />
  }

  if (!isAllowedPage) {
    return null
  }

  return (
    <Stack
      screenOptions={{
        // No native header: auth uses the in-app back control from
        // AuthScreenShell so it matches the rest of the app, which draws its
        // own chrome. A native header would also pick up the iOS 26 glass
        // treatment and look foreign next to our screens.
        headerShown: false,
        contentStyle: { backgroundColor: BRAND_COLORS.pageBg },
      }}
    >
      <Stack.Screen
        name="login"
        options={{
          gestureEnabled: false,
        }}
      />
      <Stack.Screen name="signup" />
      <Stack.Screen name="email-confirmation" />
    </Stack>
  )
}
